export default {
	home: {
		afunOriginals: "AFun ออริจินัล",
		slots: "สล็อต",
		liveCasino: "คาสิโนสด",
		casualGames: "เกมสบายๆ",
		newReleases: "เกมใหม่",
		casinoTitle: "คาสิโน",
		casinoDesc: "เพลิดเพลินกับเกมคาสิโนหลายพันเกม ดีลเลอร์สด และเกมโต๊ะ",
		goToCasino: "ไปที่คาสิโน",
		sportsTitle: "กีฬา",
		sportsDesc: "เดิมพันฟุตบอล บาสเก็ตบอล เทนนิส และกีฬาอื่นๆ ด้วยอัตราต่อรองที่ดีที่สุด",
		goToSports: "ไปที่กีฬา",
		liveTitle: "สด",
		liveDesc: "การเล่นแบบเรียลไทม์กับดีลเลอร์สดและประสบการณ์เกมแบบโต้ตอบ",
		goToLive: "ไปที่สด",
		latestBetRace: "การเดิมพันและการแข่งขันล่าสุด",
		sports: "กีฬา",
		latestBets: "การเดิมพันล่าสุด",
		game: "เกม",
		player: "ผู้เล่น",
		bet: "เดิมพัน",
		multiplier: "ตัวคูณ",
		profit: "กำไร",
		top10Games: "10 เกมยอดนิยม",
		vip: "VIP",
		rewards: "รางวัล",
		affiliate: "พันธมิตร",
		promotion: "โปรโมชั่น"
	},

	latestBetRace: {
		title: "กรังด์ปรีซ์กระดานผู้นำเกม",
		playerBetRank: "เดิมพันของผู้เล่นวันนี้",
		playerWinRank: "ชนะของผู้เล่นวันนี้",
		gameBetRank: "เดิมพันของเกมวันนี้",
		gameWinRank: "ผลตอบแทนของเกมวันนี้",
		player: "ผู้เล่น",
		game: "เกม",
		bet: "เดิมพัน",
		profit: "ชนะ",
		ratio: "อัตราจ่าย",
		totalBet: "เดิมพันรวม",
		totalReturn: "ผลตอบแทนรวม",
		maxBet: "เดิมพันสูงสุด",
		gameRatio: "% ผลตอบแทน",
		noData: "ไม่มีข้อมูล",
	},

	GameClassify: {
		casinoTitle: "คาสิโน",
		casinoDesc: "สนุกกับเกมคาสิโนจากผู้ให้บริการชั้นนำ",
		casinoBtn: "ไปที่คาสิโน",
		sportsTitle: "กีฬา",
		sportsDesc: "เดิมพันฟุตบอล คริกเก็ต NFL อีสปอร์ต และกีฬาอื่นๆ กว่า 80 ชนิด",
		sportsBtn: "ไปที่กีฬา",
		liveTitle: "ไลฟ์",
		liveDesc: "สัมผัสประสบการณ์สดแบบเรียลไทม์กับดีลเลอร์จริง",
		liveBtn: "ไปที่ไลฟ์"
	}
}